import { Point } from "ol/geom";
import Feature from "ol/Feature";
import {
  Icon,
  Style,
  Circle,
  Stroke,
  Fill,
  Text,
  RegularShape,
} from "ol/style";
import { fromLonLat } from "ol/proj";

import flagicon from "../../images/flag.png";
import pinicon from "../../images/pin.png";

import { colors, emptys } from "../../data/main";

import { avatarImages } from "../../data/avatarsData.js";
import { svgIcons } from "../../data/svgIcons.js";
import { eventsImages } from "../../data/eventsData.js";

export const createMarker = (data, type, _layer, _keep, _callback, _result) => {
  var t_point = data["PUNTOS"];
  if (!_keep) {
    if (["pin", "empty"].includes(type)) {
      t_point = type + "_" + data["PUNTOS"];
      if (data.COORDS) {
        _keep = data.COORDS;
      } else {
        _keep = fromLonLat([data.LAT2, data.LON2]);
      }
    } else {
      _keep = fromLonLat([data.LAT, data.LON]);
    }
  }

  //console.log(data['PUNTOS'])

  var tcolor = false;

  if (type === "point") {
    if (!emptys.includes(data.COLOR)) {
      tcolor = [...colors.single];
      tcolor[0] = data.COLOR;
    }
  }

  const iconFeature = new Feature({
    id: t_point,
    point: data.SEC,
    section: data.SECTION,
    obs: data.OBSER,
    group: type,
    color: tcolor,
    map: data.TER,
    shape: data.SHAPE,
    geometry: _keep !== -1 ? new Point(_keep) : null,
  });
  var iconStyle = false;

  switch (type) {
    case "mapEvent":
      if (data.type < 1 || data.type > eventsImages.length) {
        data.type = 1;
      }
      iconStyle = new Style({
        image: new Icon({
          anchor: [0.5, eventsImages["v" + data.type].anchor ?? 120],
          anchorXUnits: "fraction",
          anchorYUnits: "pixels",
          opacity: 1.0,
          src: eventsImages["v" + data.type].svg,
          scale: 0.15,
        }),
        text:
          data.type === 1 && data.name !== ""
            ? new Text({
                text: data.name,
                offsetY: 23,
                font: "15px Calibri,sans-serif",
                fill: new Fill({
                  color: "#000",
                }),
              })
            : null,
      });
      break;
    case "avatar":
      if (data.avatar < 1 || data.avatar > avatarImages.length) {
        data.avatar = 1;
      }
      iconStyle = new Style({
        image: new Icon({
          anchor: [0.5, avatarImages["ani" + data.avatar].anchor ?? 120],
          anchorXUnits: "fraction",
          anchorYUnits: "pixels",
          opacity: 1.0,
          src: avatarImages["ani" + data.avatar].svg,
          scale: 0.15,
        }),
        text: new Text({
          text: data.name,
          offsetY: 23,
          font: "bold 18px Calibri,sans-serif",
          fill: new Fill({
            color: "#000",
          }),
        }),
      });
      break;
    case "flag":
      iconStyle = new Style({
        image: new Icon({
          anchor: [0, 28],
          anchorXUnits: "pixels",
          anchorYUnits: "pixels",
          src: flagicon,
        }),
      });
      break;
    case "point":
      iconStyle = newStyle(data.SEC, data.STATUS, data.SHAPE);
      break;
    case "np":
      iconStyle = new Style({
        image: new RegularShape({
          points: 4,
          radius: 8,
          radius2: 0,
          angle: Math.PI / 4,
          stroke: new Stroke({ color: "red", width: 2 }),
          fill: new Fill({ color: "red" }),
        }),
        text: new Text({
          text: data.SEC.toString(),
          offsetY: -13,
          font: "bold 18px Calibri,sans-serif",
          fill: new Fill({ color: "#000" }),
        }),
      });
      break;
    case "pin":
      iconStyle = new Style({
        image: new Icon({
          anchor: [9, 34],
          scale: 0.73,
          anchorXUnits: "pixels",
          anchorYUnits: "pixels",
          src: pinicon,
        }),
        text: new Text({
          text: data.SEC.toString(),
          offsetY: -33,
          font: "bold 18px Calibri,sans-serif",
          fill: new Fill({ color: "#000" }),
        }),
      });
      break;
    case "empty":
      iconStyle = new Style({
        image: new RegularShape({
          points: 0,
          radius: 0,
          radius2: 0,
          angle: Math.PI / 4,
          stroke: new Stroke({ color: "red", width: 0 }),
          fill: new Fill({ color: "red" }),
        }),
        // text: new Text({
        //   text: data.SEC.toString(),
        //   offsetY: -43,
        //   font: "bold 18px Calibri,sans-serif",
        //   fill: new Fill({ color: "#000" }),
        // }),
      });
      break;
    default:
      break;
  }

  iconFeature.setStyle(iconStyle);
  //console.log(data)

  if (["pin", "empty"].includes(type) && data.COORDS) {
    _callback(iconFeature);
  }

  _layer.getSource().addFeature(iconFeature);

  if (_result) {
    return iconFeature;
  }
};

export const newStyle = (_number, _color = colors.done, shape) => {
  let image = shape
    ? new Icon({
        color: _color[0],
        anchor: svgIcons[shape].anchor,
        anchorXUnits: "pixels",
        anchorYUnits: "pixels",
        src: svgIcons[shape].svg,
        scale: 1.5,
      })
    : new Circle({
        radius: 8,
        stroke: new Stroke({ color: _color[1], width: 3 }),
        fill: new Fill({ color: _color[0] }),
      });
  return new Style({
    image,
    text: new Text({
      text: _number.toString(),
      offsetY: -15,
      font: "bold 18px Calibri,sans-serif",
      fill: new Fill({ color: "#000" }),
    }),
  });
};

export const writeColor = (_color) => {
  return [_color, colors.single[1]];
};
